export default {
  CHANGE_GLOBAL_BOOKING_LIMIT: [{ method: 'PUT', path: 'metadata/{region}/BOOKING/booking_limit' }],
};
